// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2y-s6","placeholdersHeader":"styles_placeholdersHeader__3j5L4","editorStyle":"styles_editorStyle__24Rp_","placeholdersBox":"styles_placeholdersBox__1tTuK"};